import { Cookies } from 'react-cookie';

import { ApiObjectResponse } from './types';

import axiosInterceptor from 'api/interceptor/axiosClient';

export const deleteObject = async (id: number) => {
  const cookies = new Cookies();
  const token = cookies.get('local_access_token');
  const data = await axiosInterceptor.delete(`/objects/${id}/`, {
    headers: {
      Authorization: token,
    },
  });

  return data.data as ApiObjectResponse;
};
